import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthentificationService } from '../services/auth/authentification.service';
import { StorageUtil } from '../utils/storage.util';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthentificationService, private router: Router) {}

  canActivate() {
    if(this.authService.loggedIn()) {
      return true;
    } else {
      StorageUtil.clear();
      // this.router.navigate(['login']);
      this.router.navigate(['/']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/auth.guard.ts